class JewelryCascadeFilters extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.handleChange);
    this.syncDisabledState();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.handleChange);
  }

  get selects() {
    return Array.from(this.querySelectorAll('[data-filter-step-select]'));
  }

  handleChange = (event) => {
    const changedSelect = event.target;
    if (!(changedSelect instanceof HTMLSelectElement)) return;

    const selects = this.selects;
    const changedIndex = selects.indexOf(changedSelect);
    if (changedIndex === -1) return;

    // A new choice in an earlier step clears later choices before Shopify's
    // native facets handler serializes the form and refreshes the collection.
    for (const select of selects.slice(changedIndex + 1)) {
      select.value = '';
    }

    this.syncDisabledState();
  };

  syncDisabledState() {
    let previousStepIsSelected = true;

    for (const select of this.selects) {
      select.disabled = !previousStepIsSelected;
      const field = select.closest('[data-filter-step]');
      if (field) field.hidden = !previousStepIsSelected;
      previousStepIsSelected = select.value !== '';
    }
  }
}

if (!customElements.get('jewelry-cascade-filters')) {
  customElements.define('jewelry-cascade-filters', JewelryCascadeFilters);
}
